import { useCallback, useEffect, useState } from "react";
import { FileItem } from "../models/polymer/Document.model";
import { AxiosProgressEvent } from "axios";
import { PolymerAxios } from "../utils/axios";
import { API_UploadFileWithUuid_V2, API_UploadFile_V2 } from "../utils/api";
import { useAppSelector } from "../redux/hook";
import { UploadFileType } from "../models/enum/upload-file-type.enum";

interface FileUploadPayload{
  file_name: string,
  data: string,
}

/**
 * 
 * @param initial_file The file that will be passed to this hook to upload.
 * @description this hook will accept the file that will be uploaded and file id will be returned from the API.
 * @returns file_id
 */
export const useUploadingFile = ( initial_file?:FileItem, type?: UploadFileType, folderName?: string ) => {
  const [ fileId, setFileId ] = useState<number>(0);
  const [ hasUploaded, setUploaded ] = useState<boolean>(!!initial_file?.file_id);
  const [ progress, setProgress ] = useState<number>(0);
  const [ submittedDate, setSubmittedDate ] = useState<string>("");
  const [ key, setKey ] = useState<string>(""); 
  const applicationId = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const queryParameters = new URLSearchParams(window.location.search);
  const applicationUuidFromUrl = queryParameters.get("applicationUuid");
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);

  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  
  const onProgressProcess = useCallback((e:AxiosProgressEvent) =>{
    let tempProgress = progress;
    if(e.total){
      tempProgress = (e.loaded / e.total) * 100;
    }
    setProgress(tempProgress);
  },[progress]);


  const uploadFileFunction = useCallback(( code:string, fileType:string,submitData:FileUploadPayload, controller:AbortController, file?:FileItem) => {
      let submitUrl = ""
      const size = file?.file_content?.size ?? 0;
      if(type === 1 || type === 3){
        submitUrl = `${API_UploadFile_V2}?documentCode=${code}&documentType=${fileType}`;
      }
      else if(type === 2){
        submitUrl = `${API_UploadFileWithUuid_V2}/${applicationId ?? applicationUuidFromUrl}?folderName=${folderName}&documentType=${fileType}`
      }
      
      PolymerAxios(loginUser?.uinfin ?? "", singpassToken, "", "multipart/form-data", size, encodeURIComponent(file?.file_content.file_name ?? "")).post(submitUrl ,submitData,{
        signal:controller.signal,
        onUploadProgress:onProgressProcess,
      }).then(async res=>{
        if(res.status === 200){
          const file_id = res.data.uuid;
          console.log("File uploaded API ---> ",res.data.uuid);
          setTimeout(() => {
            setUploaded(true);
          }, 1000)
    

          setFileId(file_id);
          setKey(res.data.key);
          setSubmittedDate(res.data.submitted_date);
        }
        else{
          setUploaded(false);
          setFileId(0);
        }
      }).catch(e=>{
        console.log("error",e);
        setProgress(-1);
        setUploaded(false);
        setFileId(0);
      });
    
  },[applicationId, folderName, loginUser?.uinfin, onProgressProcess, type, singpassToken])

  const processInitFile = (controller:AbortController, file?:FileItem) =>{
    //only no file id will go through this
    if(file && !hasUploaded){


      const code = file.code;
      let fileName = file.file_content.file_name ?? "";
      let fileType = "";
     
      let submitData:FileUploadPayload = {
        file_name: fileName,
        data: `${file.file_content.file_base_64?.toString()}`,
      }
      
      if(!file?.file_id && file?.file){ 
        uploadFileFunction(code,fileType,submitData,controller,file);
      }
      
      
    }
  }

  useEffect(()=>{
    if(initial_file?.file){
      let controller = new AbortController();
      let timeoutId:number;

      timeoutId = window.setTimeout(()=>{
        processInitFile(controller, initial_file);
      },100);
      return () =>{
        clearTimeout(timeoutId);
        controller?.abort();
      }
    }
  },[initial_file])


  const setCompleted = useCallback(() =>{
    setUploaded(true);
    setFileId(0);
  },[])

  return { progress, hasUploaded, fileId, setCompleted, key, submittedDate }
}
